import { formatCnpj } from "@/lib/utils"
import type { Visao } from "./schema"

const DATA = new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" })

// Quem abre um link encaminhado precisa saber de cara de que empresa é a página. Nome e CNPJ vêm
// antes de qualquer número, na mesma faixa de marca da tela de repasse: o RH que usa as duas não
// deveria ter de reaprender onde a empresa aparece.
//
// O CNPJ é o completo para o qual o link foi assinado. Os leilões só guardam a raiz; ela entra só
// enquanto o serviço não devolve o completo, e ainda identifica a empresa.
export const CabecalhoEmpresa = ({ employer, window }: Pick<Visao, "employer" | "window">) => {
    const cnpj = employer.cnpj ?? employer.cnpj_root
    const local = [employer.city, employer.state].filter(Boolean).join("/")
    const periodo =
        window.from && window.to
            ? `${DATA.format(window.from)} a ${DATA.format(window.to)}`
            : undefined

    return (
        <header className="mb-6 overflow-hidden rounded-xl border border-line bg-card shadow-sm">
            <div className="flex flex-wrap items-center justify-between gap-4 bg-brand px-6 py-5 text-brand-ink">
                <div>
                    <p className="text-xs font-semibold uppercase tracking-wide opacity-90">
                        Consignado dos seus colaboradores
                    </p>
                    <h1 className="mt-1 font-display text-2xl font-black">
                        {employer.name ?? "Sua empresa"}
                    </h1>
                    <p className="mt-0.5 text-sm opacity-90">
                        CNPJ <span className="font-mono">{formatCnpj(cnpj)}</span>
                        {local && ` · ${local}`}
                    </p>
                </div>
                {periodo && (
                    <span className="rounded-full bg-white/15 px-3 py-1.5 font-mono text-xs">
                        Pedidos de {periodo}
                    </span>
                )}
            </div>
            <p className="px-6 py-3 text-sm text-faint">
                Tudo aqui é contagem. Nenhum nome, CPF ou valor individual aparece: esta página
                descreve a folha, nunca uma pessoa.
            </p>
        </header>
    )
}
